module.exports = __webpack_public_path__ + "img/mode_2.a1761de2.png";